<template>
  <w-icon-wrapper icon-name='work-company-icon'>
    <g
      id="Gruppe_25441"
      data-name="Gruppe 25441"
      transform="translate(-1024 -929)"
    >
      <g
        id="_32_Firma_Unternehmen_Icon"
        data-name="32 Firma / Unternehmen_Icon"
        transform="translate(1024 929)"
      >
        <g
          id="Pfad_55741"
          data-name="Pfad 55741"
          fill="none"
          stroke-miterlimit="10"
        >
          <path
            d="M14,10V0H0V24H24V10ZM12,22H8V18H6v4H2V2H12V22Zm10,0H19V18H17v4H14V12h8Z"
            stroke="none"
          />
          <path
            d="M 0 0 L 14 0 L 14 10 L 24 10 L 24 24 L 14 24 L 12 24 L 0 24 L 0 0 Z M 12 22 L 12 10 L 12 2 L 2 2 L 2 22 L 6 22 L 6 18 L 8 18 L 8 22 L 12 22 Z M 22 22 L 22 12 L 14 12 L 14 22 L 17 22 L 17 18 L 19 18 L 19 22 L 22 22 Z"
            stroke="none"
            fill="currentColor"
          />
        </g>
        <g
          id="Ellipse_1526"
          data-name="Ellipse 1526"
          transform="translate(4 4)"
          fill="none"
          stroke="currentColor"
          stroke-miterlimit="10"
          stroke-width="2"
        >
          <circle
            cx="1"
            cy="1"
            r="1"
            stroke="none"
          />
          <circle
            cx="1"
            cy="1"
            fill="none"
          />
        </g>
        <g
          id="Ellipse_1527"
          data-name="Ellipse 1527"
          transform="translate(8 4)"
          fill="none"
          stroke="currentColor"
          stroke-miterlimit="10"
          stroke-width="2"
        >
          <circle
            cx="1"
            cy="1"
            r="1"
            stroke="none"
          />
          <circle
            cx="1"
            cy="1"
            fill="none"
          />
        </g>
        <g
          id="Ellipse_1528"
          data-name="Ellipse 1528"
          transform="translate(4 8)"
          fill="none"
          stroke="currentColor"
          stroke-miterlimit="10"
          stroke-width="2"
        >
          <circle
            cx="1"
            cy="1"
            r="1"
            stroke="none"
          />
          <circle
            cx="1"
            cy="1"
            fill="none"
          />
        </g>
        <g
          id="Ellipse_1529"
          data-name="Ellipse 1529"
          transform="translate(8 8)"
          fill="none"
          stroke="currentColor"
          stroke-miterlimit="10"
          stroke-width="2"
        >
          <circle
            cx="1"
            cy="1"
            r="1"
            stroke="none"
          />
          <circle
            cx="1"
            cy="1"
            fill="none"
          />
        </g>
        <g
          id="Ellipse_1530"
          data-name="Ellipse 1530"
          transform="translate(4 12)"
          fill="none"
          stroke="currentColor"
          stroke-miterlimit="10"
          stroke-width="2"
        >
          <circle
            cx="1"
            cy="1"
            r="1"
            stroke="none"
          />
          <circle
            cx="1"
            cy="1"
            fill="none"
          />
        </g>
        <g
          id="Ellipse_1531"
          data-name="Ellipse 1531"
          transform="translate(8 12)"
          fill="none"
          stroke="currentColor"
          stroke-miterlimit="10"
          stroke-width="2"
        >
          <circle
            cx="1"
            cy="1"
            r="1"
            stroke="none"
          />
          <circle
            cx="1"
            cy="1"
            fill="none"
          />
        </g>
      </g>
      <circle
        id="Ellipse_1533"
        data-name="Ellipse 1533"
        cx="1"
        cy="1"
        r="1"
        transform="translate(1028 933)"
        fill="currentColor"
      />
      <circle
        id="Ellipse_1536"
        data-name="Ellipse 1536"
        cx="1"
        cy="1"
        r="1"
        transform="translate(1028 937)"
        fill="currentColor"
      />
      <circle
        id="Ellipse_1538"
        data-name="Ellipse 1538"
        cx="1"
        cy="1"
        r="1"
        transform="translate(1028 941)"
        fill="currentColor"
      />
      <circle
        id="Ellipse_1534"
        data-name="Ellipse 1534"
        cx="1"
        cy="1"
        r="1"
        transform="translate(1032 933)"
        fill="currentColor"
      />
      <circle
        id="Ellipse_1535"
        data-name="Ellipse 1535"
        cx="1"
        cy="1"
        r="1"
        transform="translate(1032 937)"
        fill="currentColor"
      />
      <circle
        id="Ellipse_1537"
        data-name="Ellipse 1537"
        cx="1"
        cy="1"
        r="1"
        transform="translate(1032 941)"
        fill="currentColor"
      />
    </g>
  </w-icon-wrapper>
</template>

<script>
export default { name: 'WorkIconCompany' };
</script>
